import { useRef, useCallback } from 'react'
import { sendMessageToEmbed } from './utils/embedCommunication'

export const useSyncIframeSize = () => {
  const setSize = useCallback((width: number, height: number) => {
    const size = {
      width: `${width}px`,
      height: `${height}px`,
    }
    sendMessageToEmbed({
      type: 'SET_SIZE',
      value: size,
    })
  }, [])

  const observer = useRef(
    new ResizeObserver(entries => {
      const entry = entries[0]
      if (entry?.target.children.length) {
        setSize(entry.contentRect.width, entry.contentRect.height)
      }
    })
  )

  const setComponentToSyncToRef = useCallback(
    (component: HTMLDivElement | HTMLButtonElement | null) => {
      if (component) {
        setSize(component.clientWidth, component.clientHeight)
        observer.current.observe(component)
      } else {
        observer.current.disconnect()
      }
    },
    [setSize]
  )

  return setComponentToSyncToRef
}
